import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-content-area',
    imports: [NgOptimizedImage],
    templateUrl: './content-area.component.html',
    styleUrl: './content-area.component.scss'
})
export class ContentAreaComponent {
    assetsCDNUrl = environment.assetsCDNUrl;
    data =
        { title1: "Our Vision", desc1: "<p>To be the most trusted partner, maximizing your wealth to create value that endures over time.</p>", imageUrl1: "/assets/images/our-vision.webp", title2: "Our Mission", desc2: "<p>To deliver personalized, transparent, and research-driven solutions, always prioritizing relationships over transactions.</p>", imageUrl2: "/assets/images/our-vision1.webp" }
}
